import ApiDocsPage from './ApiDocsPage';

export default ApiDocsPage; 